import { NavigationInstruction, Redirect, Router } from "aurelia-router";
import { autoinject } from "aurelia-dependency-injection";
import { GenesisRouterConstants } from "../../configuration/router.constants";
import { Next } from "aurelia-router";
import { UserClientService } from "../../services/authentication/user-client.service";
import { RedirectToRoute } from "aurelia-router";

@autoinject
export class AuthorizeStep {

    constructor(private userClientService: UserClientService, private router: Router) {
    }

    run(navigationInstruction: NavigationInstruction, next: Next): Promise<any> {
        if (navigationInstruction.config.auth && navigationInstruction.config.name != "login" && !this.userClientService.currentUser) {
            const href = location.href.replace(location.origin, '').replace(this.router.options.root != "/" ? this.router.options.root : "", "");
            const params = href ? { referrer: href } : {};
            return next.cancel(new RedirectToRoute(GenesisRouterConstants.RouteNames.Login, params));
        } else if ((navigationInstruction.config.name == "login" || navigationInstruction.config.name == "register") && this.userClientService.currentUser) {
            return next.cancel(new Redirect(""));
        }

        return next();
    }
}

